import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTableFilter,
  hasPermission,
  TABLE_CONSTANTS_COLUMS,
  hasAllPermissions,
  useCheckPermissions,
 } from '@/shared';
import { useFetchUbicaciones } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import { Ubicaciones } from '@/shared/interfaces/erp/inventario';
import { PermissionsEnum } from '@/auth/interfaces';

const returnUrlUbicaciones = '/inventario/ubicaciones';

export interface UbicacionesPageInterface {}

const UbicacionesPage: React.FC<UbicacionesPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ubicacion);

  const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: UbicacionesPagingRes,
    isLoading,
    isRefetching,
  } = useFetchUbicaciones({
    page: pageIndex + 1,
    nombre: searchTerm,
    filterByState: false,
  });
  ///* handlers
  const onEdit = (original:   Ubicaciones) => {
    navigate(`${returnUrlUbicaciones}/editar/${original.id_ubicacion}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<Ubicaciones>[]>(
    () => [
      {
        accessorKey: 'numero_referencia',
        header: 'numero referencia',
        size: 90,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'bodega_data.nombre',
        header: 'bodega',
        size: 300,
      },
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Ubicaciones de productos" urlRedirect={`${returnUrlUbicaciones}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_ubicacion)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Ubicaciones de productos" cleanFilter={cleanFilter} />

      <GeneralTable<Ubicaciones>
        columns={columns}
        data={UbicacionesPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_ubicacion,
        ])}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={UbicacionesPagingRes?.data?.count}
        actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}

        // // actions
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_ubicacion,
        ])}
        // crud
        onEdit={onEdit}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default UbicacionesPage;
